export default "__VITE_ASSET__CdlPwNNh__"